import { Upload } from 'antd';
import styled from 'styled-components';

const { Dragger: antdDragger } = Upload;

const Dragger = styled(antdDragger)`
  min-height: 100vh;
  border: none !important;
  cursor: inherit !important;

  // Ant Design renders these wrappers as table/table-cell, which propagates
  // wide route content into the application shell's intrinsic width.
  && > .ant-upload-btn,
  && > .ant-upload-btn > .ant-upload-drag-container {
    display: block;
  }

  &.ant-upload-drag-hover {
    filter: ${({ disabled }) => !disabled && 'brightness(0.5)'};
  }

  body.pspdfkit-document-editor-open &.ant-upload-drag-hover {
    filter: unset;
  }
  & .ant-upload.ant-upload-disabled {
    cursor: inherit;
  }
  & .ant-upload {
    padding: 0 !important;
  }
`;

export default Dragger;
